<script setup lang="ts">
import type { StickerFill } from '../SfgSticker.vue'

/**
 * SfgLightning2 — double-zigzag lightning bolt sticker. Two
 * horizontal jogs along the descent. Slightly taller aspect than
 * SfgLightning1 (5:7) to fit the extra bend.
 */

const props = withDefaults(defineProps<{
  border?: StickerFill
  fill?: StickerFill
  size?: number | string
  tilt?: number
}>(), {
  border: 'ink',
  fill: 'yellow',
  size: 80,
  tilt: 8,
})

const heightCss = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
const widthCss = computed(() => {
  if (typeof props.size === 'number') {
    return `${props.size * (100 / 140)}px`
  }
  return `calc(${props.size} * ${100 / 140})`
})
const fillVar = computed(() => `var(--color-brand-${props.fill})`)
const strokeVar = computed(() => `var(--color-brand-${props.border})`)
</script>

<template>
  <svg
    aria-hidden="true"
    :style="{
      width: widthCss,
      height: heightCss,
      transform: `rotate(${tilt}deg)`,
      filter: 'drop-shadow(0 3px 0 rgba(0, 0, 0, 0.6))',
    }"
    viewBox="0 0 100 140"
  >
    <path
      d="M58 5 L24 38 L46 38 L18 78 L42 78 L12 135 L78 70 L48 70 L66 30 L46 30 Z"
      :fill="fillVar"
      :stroke="strokeVar"
      stroke-width="4"
      stroke-linejoin="round"
      stroke-linecap="round"
    />
  </svg>
</template>
